export const icons = {
  home: "home",
  dashboard: "dashboard",
  project: "project",
  logs: "read",
  client: "idcard",
  tailgate: "audit",
  incident: "alert",
  note: "exclamation-circle",
  sse: "monitor",
  photo: "camera",
  document: "picture",
  messages: "message",
  risk: "flag",
  user: "user",
  admin: "tags",
  submission: "sliders",
  dashestimation: "control",
  calendar: "calendar",
  plus: "plus",
};
